import moment from 'moment';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setStateModalDetail } from '../pages/manager-meeting/modelPeriodSlice';
import apiManagerNotification from '../api/meeting-notification';
import apiManagerRoom from '../api/manager-meeting';
import { t } from 'i18next';
import { setEmail } from 'store/user/accountInfo';
import { setOpenModal } from 'store/modal/modalSlice';
import OtpDialog from './Dialog/OtpDialog';
import { useNavigate } from 'react-router-dom';
import { setRoomDetail } from 'pages/subtitles/components/Table/store/managerSubsSlice';
import { toastInfo, toastWarning } from 'utils/helpers';
import { PATH_ROOT } from 'constants/api';
import { COMPONENT_RENDER } from 'constants/common';
import { Typography } from '@mui/material';
import { isDefaultColorSystem } from 'utils/functions';

const detailCustomType = [7, 8, 9, 10, 11];

function convertNoti(noti) {
    if (noti?.messageObject) {
        const message = JSON.parse(noti.messageObject);
        let _noti = noti;
        for (const property in message) {
            _noti[property] = message[property];
        }
        return _noti;
    }

    return false;
}

function convertTimeMeet(noti) {
    const {
        startTime = '',
        endTime = '',
        previousStartTime = '',
        previousEndTime = '',
        currentStartTime = '',
        currentEndTime = '',
        startTimeSecond = '',
        endTimeSecond = '',
        loginTime = '',
    } = noti;

    let _startTime = moment(startTime).format('DD/MM/YYYY');
    let _endTime = moment(endTime).format('DD/MM/YYYY');
    let _previousStartTime = moment(previousStartTime).format('DD/MM/YYYY');
    let _previousEndTime = moment(previousEndTime).format('DD/MM/YYYY');
    let _currentStartTime = moment(currentStartTime).format('DD/MM/YYYY');
    let _currentEndTime = moment(currentEndTime).format('DD/MM/YYYY');
    let startTimeH = moment(startTime).format('HH:mm');
    let endTimeH = moment(endTime).format('HH:mm');
    let previousStartTimeH = moment(previousStartTime).format('HH:mm');
    let previousEndTimeH = moment(previousEndTime).format('HH:mm');
    let currentStartTimeH = moment(currentStartTime).format('HH:mm');
    let currentEndTimeH = moment(currentEndTime).format('HH:mm');
    let startTimeSecondDMY = moment.unix(startTimeSecond).format('DD/MM/YYYY');
    let endTimeSecondDMY = moment.unix(endTimeSecond).format('DD/MM/YYYY');
    let startTimeSecondH = moment.unix(startTimeSecond).format('HH:mm');
    let endTimeSecondH = moment.unix(endTimeSecond).format('HH:mm');
    let loginTimeH = moment(loginTime).format('HH:mm');
    let loginTimeSecondDMY = moment(loginTime).format('DD/MM/YYYY');

    return {
        startTime: _startTime,
        endTime: _endTime,
        previousStartTime: _previousStartTime,
        previousEndTime: _previousEndTime,
        currentStartTime: _currentStartTime,
        currentEndTime: _currentEndTime,
        startTimeH,
        endTimeH,
        previousStartTimeH,
        previousEndTimeH,
        currentStartTimeH,
        currentEndTimeH,
        startTimeSecondDMY,
        endTimeSecondDMY,
        startTimeSecondH,
        endTimeSecondH,
        loginTimeH,
        loginTimeSecondDMY,
    };
}

function convertModeMeeting(meetingMode) {
    if (meetingMode === 1 || meetingMode === '1') {
        return t('meetingNotification.privateMeeting');
    }

    return '';
}

function renderNotiTitle(content) {
    return <span className="content-noti-title">{content}</span>;
}

function contentNoti(noti, t) {
    const {
        notificationType: type,
        nameOfRoomCreator,
        roomName,
        nameOfUser,
        isPeriod,
        meetingMode = '',
        device,
        email,
        nameOwnerSub,
        ownerName,
    } = noti;
    const {
        loginTimeH,
        loginTimeSecondDMY,
        startTime,
        previousStartTime,
        currentStartTime,
        startTimeH,
        endTimeH,
        previousStartTimeH,
        previousEndTimeH,
        currentStartTimeH,
        currentEndTimeH,
        startTimeSecondDMY,
        startTimeSecondH,
        endTimeSecondH,
    } = convertTimeMeet(noti);

    const _meetingMode = convertModeMeeting(meetingMode);

    const displayIsPeriod = isPeriod === 'yes' ? t('meetingNotification.displayIsPeriod') : '';

    let content = '';
    let title = '';
    switch (type) {
        case 0:
            title = t('meetingNotification.inviationNoti_title');
            content = (
                <span>
                    {t('meetingNotification.inviationNoti_1')}
                    {_meetingMode}
                    {renderNotiTitle(roomName)}
                    {displayIsPeriod}
                    {t('meetingNotification.inviationNoti_2')}
                    {renderNotiTitle(nameOfRoomCreator)}.
                </span>
            );
            break;
        case 1:
            title = t('meetingNotification.cancelNoti_title');
            content = (
                <span>
                    {t('meetingNotification.noti_meeting')}
                    {_meetingMode}
                    {renderNotiTitle(roomName)}
                    {t('meetingNotification.noti_atTime')}
                    {renderNotiTitle(startTime)}
                    {t('meetingNotification.noti_from')}
                    {renderNotiTitle(startTimeH)}
                    {t('meetingNotification.noti_to')}
                    {renderNotiTitle(endTimeH)}
                    {t('meetingNotification.cancelNoti_2')}
                </span>
            );
            break;
        case 2:
            title = t('meetingNotification.updateNoti_title');
            content = (
                <span>
                    {t('meetingNotification.noti_meeting')}
                    {_meetingMode}
                    {renderNotiTitle(roomName)}
                    {t('meetingNotification.noti_atTime')}
                    {renderNotiTitle(previousStartTime)}
                    {t('meetingNotification.noti_from')}
                    {renderNotiTitle(previousStartTimeH)}
                    {t('meetingNotification.noti_to')}
                    {renderNotiTitle(previousEndTimeH)}
                    {t('meetingNotification.updateNoti_1')}
                    {renderNotiTitle(currentStartTime)}
                    {t('meetingNotification.noti_from')}
                    {renderNotiTitle(currentStartTimeH)}
                    {t('meetingNotification.noti_to')}
                    {renderNotiTitle(currentEndTimeH)}.
                </span>
            );
            break;
        case 3:
            title = t('meetingNotification.acceptNoti_title');
            content = (
                <span>
                    {renderNotiTitle(nameOfUser)}{' '}
                    <span style={{ color: '#006339', fontWeight: 600, fontStyle: 'italic' }}>
                        {t('meetingNotification.acceptNoti_1')}
                    </span>
                    {t('meetingNotification.noti_joinMeeting')}
                    {_meetingMode}
                    {renderNotiTitle(roomName)}
                    {t('meetingNotification.noti_atTime')}
                    {renderNotiTitle(startTime)}
                    {t('meetingNotification.noti_from')}
                    {renderNotiTitle(startTimeH)}
                    {t('meetingNotification.noti_to')}
                    {renderNotiTitle(endTimeH)}.
                </span>
            );
            break;
        case 4:
            title = t('meetingNotification.denyNoti_title');
            content = (
                <span>
                    {renderNotiTitle(nameOfUser)}{' '}
                    <span style={{ color: '#C70000', fontWeight: 600, fontStyle: 'italic' }}>
                        {t('meetingNotification.denyNoti_1')}
                    </span>
                    {t('meetingNotification.noti_joinMeeting')}
                    {_meetingMode}
                    {renderNotiTitle(roomName)}
                    {t('meetingNotification.noti_atTime')}
                    {renderNotiTitle(startTime)}
                    {t('meetingNotification.noti_from')}
                    {renderNotiTitle(startTimeH)}
                    {t('meetingNotification.noti_to')}
                    {renderNotiTitle(endTimeH)}.
                </span>
            );
            break;
        case 5:
            if (startTimeSecondDMY !== '01/01/1970') {
                title = t('meetingNotification.upcomingNoti_title');
                content = (
                    <span>
                        {t('meetingNotification.upcomingNoti_1')}
                        {_meetingMode}
                        {renderNotiTitle(roomName)}
                        {t('meetingNotification.noti_atTime')}
                        {renderNotiTitle(startTimeSecondDMY)}
                        {t('meetingNotification.noti_from')}
                        {renderNotiTitle(startTimeSecondH)}
                        {t('meetingNotification.noti_to')}
                        {renderNotiTitle(endTimeSecondH)}.
                    </span>
                );
            } else {
                title = t('meetingNotification.upcomingNoti_title');
                content = (
                    <span>
                        {t('meetingNotification.upcomingNoti_1')}
                        {_meetingMode}
                        {renderNotiTitle(roomName)}
                        {t('meetingNotification.noti_atTime')}
                        {renderNotiTitle(startTime)}
                        {t('meetingNotification.noti_from')}
                        {renderNotiTitle(startTimeH)}
                        {t('meetingNotification.noti_to')}
                        {renderNotiTitle(endTimeH)}.
                    </span>
                );
            }
            break;
        case 6:
            title = t('meetingNotification.restoreNoti_title');
            content = (
                <span>
                    {t('meetingNotification.restoreNoti_1')}
                    {_meetingMode}
                    {renderNotiTitle(roomName)}
                    {displayIsPeriod}
                    {t('meetingNotification.inviationNoti_2')}
                    {renderNotiTitle(nameOfRoomCreator)}.
                </span>
            );
            break;
        case 7:
            title = t('meetingNotification.deleteNoti_title');
            content = (
                <span>
                    {t('meetingNotification.deleteNoti_1')}
                    {_meetingMode}
                    {renderNotiTitle(roomName)}
                    {displayIsPeriod}
                    {t('meetingNotification.deleteNoti_2')}
                    {renderNotiTitle(startTime)}
                    {t('meetingNotification.deleteNoti_from')}
                    {renderNotiTitle(startTimeH)}
                    {t('meetingNotification.deleteNoti_to')}
                    {renderNotiTitle(endTimeH)}
                    {t('meetingNotification.deleteNoti_isDeleted')}.
                </span>
            );
            break;

        case 8:
            title = t('meetingNotification.warningNewDevice');
            content = (
                <div>
                    {t('meetingNotification.contentWarning')}{' '}
                    <span style={{ fontWeight: 600 }}>
                        {device === 'Unknown' ? t('meetingNotification.newDevice') : device}
                    </span>{' '}
                    {t('meetingNotification.at')}{' '}
                    <span style={{ fontWeight: 600 }}>
                        {loginTimeH} {loginTimeSecondDMY}
                    </span>
                </div>
            );
            break;
        // Trường hợp người dùng chưa xác thực mail
        case 9:
            title = t('meetingNotification.verifyEmail');
            content = (
                <div>
                    <div>
                        {t('meetingNotification.contentEmail_1')}
                        {email}
                    </div>
                    <div>
                        {t('meetingNotification.contentEmail_2')}
                        <Typography
                            fontStyle={'italic'}
                            sx={{
                                textDecorationLine: 'underline',
                                color: (theme) => (isDefaultColorSystem() ? '#046DC1' : theme.palette.secondary.main),
                            }}
                        >
                            {t('meetingNotification.contentEmail_3')}
                        </Typography>
                    </div>
                </div>
            );
            break;
        // Trường hợp mời người tham gia bản ghi phụ đề
        case 10:
            title = t('meetingNotification.shareSub');
            content = (
                <div>
                    <span>
                        {t('meetingNotification.sharedSubBy')} {renderNotiTitle(roomName)} {t('meetingNotification.by')}{' '}
                        {renderNotiTitle(nameOwnerSub)}. {t('meetingNotification.viewDetail')}{' '}
                        <span className="url-detail-noti">{t('meetingNotification.here')}</span>
                    </span>
                </div>
            );
            break;
        // Trường hợp Bản ghi quá hạn lưu trữ
        case 11:
            title =
                JSON.stringify(JSON.parse(noti.messageObject).warning_level) === '2'
                    ? t('meetingNotification.bellOverQuotaStorageLv2')
                    : t('meetingNotification.bellOverQuotaStorageLv3');
            content = (
                <div>
                    {JSON.stringify(JSON.parse(noti.messageObject).warning_level) === '2' ? (
                        <Fragment>
                            <span>
                                {t('meetingNotification.overQuota1')}
                                <span style={{ fontWeight: 'bold' }}>90%</span>
                                {t('meetingNotification.overQuota2')}
                                <span style={{ fontStyle: 'italic', textDecoration: 'underline', color: '#1907EC' }}>
                                    {t('meetingNotification.overQuotaHere')}
                                </span>
                                {t('meetingNotification.overQuota3')}
                            </span>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <span>
                                {t('meetingNotification.overQuota4')}
                                <span style={{ fontStyle: 'italic', textDecoration: 'underline', color: '#1907EC' }}>
                                    {t('meetingNotification.overQuotaRecords')}
                                </span>
                                {t('meetingNotification.overQuota5')}
                                <span style={{ fontWeight: 'bold' }}>
                                    {moment
                                        .unix(parseInt(JSON.parse(noti.messageObject).warning_time) / 1000)
                                        .add('days', 30)
                                        .format('HH:mm, DD/MM/YYYY')}
                                </span>
                                .
                            </span>
                        </Fragment>
                    )}
                </div>
            );
            break;
        case 12:
            title = t('meetingNotification.shareStorage');
            content = (
                <div>
                    <span>
                        {t('meetingNotification.shareStorageContent')}{' '}
                        <span style={{ fontWeight: '600' }}>{ownerName}</span>
                    </span>
                </div>
            );
            break;
        default:
            break;
    }
    return { title, content };
}

const Notification = ({ noti, handleUpdateSentNoti, setOpenNotificationBox }) => {
    const _noti = convertNoti(noti);

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userInfo = useSelector((state) => state.userInfo.userInfo);
    const { parentRoomId, notificationType, unixNotifiedTime, processStatus, roomId, acceptDenyReason } = _noti;

    const handleSubmitVerifyOtp = () => {};

    var userName = localStorage.getItem('userName');

    const handleSentNoti = (noti) => {
        // dispatch(setStateModalDetail({isOpenModalDetail: false}));
        if (noti.processStatus === 0) {
            handleUpdateSentNoti(noti.id);
        }

        if (noti?.notificationType === 11) {
            setOpenNotificationBox(false);
            if (JSON.parse(noti.messageObject)?.warning_level === 2) {
                return navigate(`${PATH_ROOT}/manager-storage`);
            }
            return navigate(`${PATH_ROOT}/manager-storage?filter_over_record=1`);
        }

        // Cancel meeting
        if (
            notificationType !== 1 &&
            notificationType !== 7 &&
            notificationType !== 8 &&
            notificationType !== 9 &&
            notificationType !== 10 &&
            notificationType !== 11 &&
            notificationType !== 12
        ) {
            apiManagerRoom
                .getRoom(roomId)
                .then((res) => {
                    if (res?.data === 'ROOM_NOT_EXISTED') {
                        toastWarning(t('meetingNotification.roomWasDeleted'));
                    } else if (
                        notificationType === 0 ||
                        notificationType === 2 ||
                        notificationType === 5 ||
                        notificationType === 6
                    ) {
                        var roomName = res?.data[0].roomName;
                        if (parentRoomId) var roomIdForAPI = parentRoomId;
                        else roomIdForAPI = roomId;

                        let userCheckInRoom = {
                            userName: userName,
                            roomId: roomIdForAPI,
                        };

                        apiManagerNotification
                            .checkUserStillInRoom(userCheckInRoom)
                            .then((res) => {
                                if (res?.data === 'USER_EXIST_IN_ROOM') {
                                    setOpenNotificationBox(false);
                                    dispatch(setStateModalDetail({ isOpenModalDetail: true, roomId: noti.roomId }));
                                    setTimeout(() => {
                                        dispatch(setStateModalDetail({ isOpenModalDetail: false, roomId: '' }));
                                    }, 300);
                                } else if (res?.data === 'USER_NOT_IN_ROOM') {
                                    let notInvitedAnymore;
                                    if (res?.userHostName) {
                                        notInvitedAnymore = (
                                            <div>
                                                {t('meetingNotification.notInvitedAnymore1')}
                                                <br />
                                                {t('meetingNotification.notInvitedAnymore2')}
                                                {roomName}
                                                {t('meetingNotification.inviationNoti_2')}
                                                {res?.userHostName}
                                            </div>
                                        );
                                    } else
                                        notInvitedAnymore = (
                                            <div>
                                                {t('meetingNotification.notInvitedAnymore1')}
                                                <br />
                                                {t('meetingNotification.notInvitedAnymore2')}
                                                {roomName}
                                            </div>
                                        );
                                    toastWarning(notInvitedAnymore);
                                }
                            })
                            .catch((e) => {});
                        // setOpenNotificationBox(false)
                        // dispatch(setStateModalDetail({isOpenModalDetail: true, roomId: noti.roomId}))
                    } else if (notificationType === 3 || notificationType === 4) {
                        setOpenNotificationBox(false);
                        dispatch(setStateModalDetail({ isOpenModalDetail: true, roomId: noti.roomId }));
                    }
                })
                .catch((e) => {});
        } else if (
            notificationType !== 7 &&
            notificationType !== 8 &&
            notificationType !== 9 &&
            notificationType !== 10 &&
            notificationType !== 11 &&
            notificationType !== 12
        ) {
            setOpenNotificationBox(false);
            dispatch(setStateModalDetail({ isOpenModalDetail: true, roomId: noti.roomId }));
        } else if (notificationType === 9) {
            if (userInfo?.verifyMail) {
                dispatch(setEmail(userInfo?.email));
                setOpenNotificationBox(false);
                dispatch(
                    setOpenModal({
                        modal: (
                            <OtpDialog
                                onSubmitVerifyOtp={handleSubmitVerifyOtp}
                                componentRender={COMPONENT_RENDER.VERIFY_EMAIL}
                                checkClose={true}
                            />
                        ),
                        alwayClose: true,
                    }),
                );
            } else {
                toastInfo(t('toast.verifiedMail'));
            }
        } else if (notificationType === 10) {
            dispatch(
                setRoomDetail({
                    roomName: noti?.roomName,
                    startTime: noti?.startTimeUnix,
                    roomId: noti?.roomId,
                    userHostId: noti?.userHostId,
                }),
            );
            navigate(`${PATH_ROOT}/live-captions/detail?roomId=${noti?.roomId}&live_captions_id=${noti?.liveCaptionsId}`);
        } else if (notificationType === 12) {
            navigate(`${PATH_ROOT}/manager-storage`);
        }

        setOpenNotificationBox(false);
    };

    return (
        <>
            {_noti && (
                <div
                    className={`noti-container ${processStatus === 0 ? 'noti-unSent' : 'noti-Sent'}`}
                    onClick={() => handleSentNoti(noti)}
                    onKeyPress={() => handleSentNoti(noti)}
                    tabIndex={1}
                >
                    <div className="header-noti">
                        <span className="title-noti" style={{ fontSize: '16px' }}>
                            {contentNoti(_noti, t).title}
                        </span>
                        <span className="time-noti">{moment.unix(unixNotifiedTime).format('DD/MM/YYYY HH:mm')}</span>
                    </div>
                    <div className="content-noti-container">
                        <span className="content-noti">
                            {contentNoti(_noti, t).content}
                            {!detailCustomType.includes(_noti?.notificationType) ? (
                                t('meetingNotification.viewDetail')
                            ) : (
                                <></>
                            )}
                            {!detailCustomType.includes(_noti?.notificationType) ? (
                                <span className="url-detail-noti">{t('meetingNotification.here')}</span>
                            ) : (
                                <></>
                            )}
                        </span>
                        {acceptDenyReason && (
                            <span className="reson-noti">
                                <span className="reson-noti-title">{t('meetingNotification.reason')}</span>{' '}
                                {acceptDenyReason}
                            </span>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default Notification;
